import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import TagForm from './forms/tagForm';
import TagList from './lists/tagList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {ParentFieldSelectorGrid} from "../form/SelectorGrid/SelectorGrid";
import {ProductColumn} from "../../utils/formatters";

class tagEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Cimkék"}
                    footer={[
                        <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <TagList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Cimke"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <TagForm {...this.props} />
                </Editor>
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <Box
                        theme="default"
                        header="Termékek"
                    >
                        <ParentFieldSelectorGrid
                            componentConfig={this.props.componentConfig}
                            parentcomponent="product"
                            field="tags"
                            data={this.props.values}
                            columns={{
                                "displayname": {
                                    ...ProductColumn("id"),
                                    width: 11
                                },
                                "barcode": {
                                    header: 'Vonalkód',
                                    width: 1,
                                    sortable: true,
                                    filterable: true
                                },
                            }}
                            exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                        />
                    </Box>
                }
            </Fragment>
        );
    }
}

export default createEditor({componentName: "tag", WrappedComponent: tagEditor, props: {view: "admin"}});
